export default __webpack_public_path__ + "static/media/naamtaG.0499ce81.png";